export const collaborationPublicRoutesConstants = {
  root: {
    path: "/r/pc/collab",
    href: () => `/r/pc/collab`
  },
  crowdsource: {
    path: "/r/pc/collab/crowdsource",
    href: (token: string) => `/r/pc/collab/crowdsource?token=${token}`
  }
} as const;
